import {reduxActionsFactory} from '../_factory/actionsFactory';
import {START, SUCCESS, ERROR, RESET} from "../../actions/types";
import {BACKEND_URL_PREFIX} from "../../utils/const";
import {buildDefaultHeaders} from "../../actions/helper";
import {logger} from "redux-logger/src";
import {createNotification} from "../../components/notifications/notifications";


export const REQUEST_COURSE_BOOKS = "REQUEST_COURSE_BOOKS";
export const DELETE_COURSE_BOOK = "DELETE_COURSE_BOOK";
export const ADD_COURSE_BOOK = "ADD_COURSE_BOOK";

export const CourseBooksActions = {
    fetch: reduxActionsFactory(REQUEST_COURSE_BOOKS),
    delete: reduxActionsFactory(DELETE_COURSE_BOOK),
    add: reduxActionsFactory(ADD_COURSE_BOOK),
};

const initialState = {
    list: [],
    isLoading: false,
};

export default function courseBooksReducer(state = initialState, action) {
    switch (action.type) {
        case `${REQUEST_COURSE_BOOKS}${START}`:
            return {
                ...state,
                isLoading: true,
            };
        case `${REQUEST_COURSE_BOOKS}${SUCCESS}`:
            return {
                ...state,
                list: action.payload,
                isLoading: false,
            };
        case `${REQUEST_COURSE_BOOKS}${ERROR}`:
            return {
                ...state,
                isLoading: false,
            };
        default:
            return state;
    }
}

const requestBookInfo = (books) => async (dispatch, getState) => {
    const url = `${BACKEND_URL_PREFIX}/library/bookinfo`;
    const bookIds = books.map(item => item.library_bookid);
    const response = await fetch(`${url}`, {
        method: 'POST',
        body: JSON.stringify(bookIds),
        ...buildDefaultHeaders(getState),
    });

    if (response.ok) {
        const result = await response.json();
        const bookInfoFusion = books.map(item => ({
            ...result.find(el => +el.bookid === +item.library_bookid),
            ...item,
        }));
        dispatch(CourseBooksActions.fetch.success(bookInfoFusion));
    } else {
        dispatch(CourseBooksActions.fetch.error(response));
    }
};

export const resetCourseBooks = () => async dispatch => dispatch(CourseBooksActions.fetch.success([]));

export const fetchCourseBooks = (courseId) => async (dispatch, getState) => {
    const url = `${BACKEND_URL_PREFIX}/coursebooks/${courseId}`;

    dispatch(CourseBooksActions.fetch.start(courseId));
    const response = await fetch(`${url}`, buildDefaultHeaders(getState));

    if (response.ok) {
        const result = await response.json();
        dispatch(requestBookInfo(result));
    } else {
        dispatch(CourseBooksActions.fetch.error(response));
    }
};

export const deleteCourseBook = (id, courseId) => async (dispatch, getState) => {
    const url = `${BACKEND_URL_PREFIX}/coursebooks/${id}`;

    dispatch(CourseBooksActions.delete.start(id, courseId));
    const response = await fetch(`${url}`, {
        method: 'DELETE',
        headers: {
            'Access-Control-Allow-Origin': '*',
            Authorization: `Basic ${btoa(`${getState().auth.token}:empty`)}`,
        },
    });

    if (response.ok) {
        const data = await response.json();
        dispatch(CourseBooksActions.delete.success());
        data && dispatch(fetchCourseBooks(courseId));
    } else {
        dispatch(CourseBooksActions.delete.error());
    }
};

export const addCourseBook = (data) => async (dispatch, getState) => {
    const url = `${BACKEND_URL_PREFIX}/coursebooks/${data.courseId}`;
    const courseId = data.courseId;

    dispatch(CourseBooksActions.add.start(data));
    const response = await fetch(`${url}`, {
        method: 'POST',
        body: JSON.stringify({
            "library_bookid": data.bookId,
            "num": 2,
            "part": data.part,
            "razdel": "Основная"
        }),
        ...buildDefaultHeaders(getState),
    });
    if (response.ok) {
        const data = await response.json();

        dispatch(CourseBooksActions.add.success());
        data && dispatch(fetchCourseBooks(courseId));
    } else {
        dispatch(CourseBooksActions.add.error());
    }
};